import {Checkbox, Form} from 'antd';

const IsActiveFormItem = () => (
    <Form.Item name="active" valuePropName="checked">
        <Checkbox>Active</Checkbox>
    </Form.Item>
);

export default IsActiveFormItem;